import { Query } from "@tanstack/react-query";

// Query key prefixes that should NOT be refreshed on pull-to-refresh.
// Mostly global queries, queries with a long stale time, or queries that are not critical to refresh on pull-to-refresh.
const REFRESH_DENYLIST: string[] = [
  "user",
  "userPreferences",
  "userPermissions",
  "userAvatarFromGraph",
  "userAvatarsFromGraph",
  "graphToken",
  "countries",
  "stores",
  "focusTile",
  "close-reasons",
  "product-search-api-key",
  "uploads",
  "permissions",
  "country-permissions",
  "store-permissions",
  "item",
  "store",
  "task-types",
  "Item",
  "PIP",
  "storeTeams",
  "storeTeamsWithUsersCount",
];

export function shouldRefreshQuery(query: Query): boolean {
  const key = query.queryKey[0];
  return typeof key !== "string" || !REFRESH_DENYLIST.includes(key);
}
